import { texts } from "../data/langs";
import logo from "../assets/logo.png";
import "../App.css";

export const Footer = (props) => {
  const { setContact } = props;

  const sections = texts[texts.active].footer.sections;
  return (
    <footer id="Footer">
      <div className="foot-start limiter switch-aspect">
        <div className="brand">
          <img src={logo} alt="logo" />
        </div>

        <div className="GAP-20" />

        <div className="auto-columns">
          {sections.map((i) => {
            return (
              <>
                <div className="foot_col">
                  <span className="foot_title">{i.title}</span>

                  {mapTexts(i.texts)}

                  <div className="GAP-10" />

                  {mapLinks(i.links, setContact)}
                </div>
              </>
            );
          })}
        </div>
      </div>
    </footer>
  );
};

const mapTexts = (arrTexts) => {
  return arrTexts.map((i) => <div className="foot_texts">{i}</div>);
};

const mapLinks = (arrLinks, setContact) => {
  return arrLinks.map((i) => {
    const toggleModal = () => {
      setContact((e) => !e);
    };
    const condUrl = i?.type === "show_modal";

    const condFn = condUrl ? toggleModal : () => {};

    return (
      <a className="foot_links" href={i.url} target={i.target} onClick={condFn}>
        {i.view}
      </a>
    );
  });
};
